/* ==========================================================
   CONFIGURAÇÕES
========================================================== */

const CONFIG = {

    email: "comercial@notyourguru.com.br",

    troca: {

        assunto: "Realizar Troca",

        mensagem: `Olá!

Gostaria de solicitar uma troca.

Nome que consta no pedido:
Número do pedido:
Motivo da troca:

`

    },

    devolucao: {

        assunto: "Realizar Devolução",

        mensagem: `Olá!

Gostaria de solicitar uma devolução.

Nome que consta no pedido:
Número do pedido:
Motivo da devolução:

`

    }

};


/* ==========================================================
   FUNÇÃO PARA ABRIR O E-MAIL
========================================================== */

function abrirEmail(email, assunto, mensagem){

    const url =
        `mailto:${email}` +
        `?subject=${encodeURIComponent(assunto)}` +
        `&body=${encodeURIComponent(mensagem)}`;

    window.location.href = url;

}


/* ==========================================================
   BOTÃO TROCA
========================================================== */

document
    .getElementById("btn-troca")
    ?.addEventListener("click", () => {

        abrirEmail(
            CONFIG.email,
            CONFIG.troca.assunto,
            CONFIG.troca.mensagem
        );

    });


/* ==========================================================
   BOTÃO DEVOLUÇÃO
========================================================== */

document
    .getElementById("btn-devolucao")
    ?.addEventListener("click", () => {

        abrirEmail(
            CONFIG.email,
            CONFIG.devolucao.assunto,
            CONFIG.devolucao.mensagem
        );

    });